import {AxiosResponse} from 'axios';
import {UserType} from '../backend/enums/user-type';
import {Occupation} from '../backend/interfaces/occupation';
import {BackendApiManager} from '../managers/backend-api';
import {Logger} from '../utils/managers/logger';

export class OccupationsRepository {
  // Singleton Instance
  private static _instance: OccupationsRepository;

  // Private
  private logger: Logger;

  static get instance(): OccupationsRepository {
    if (!this._instance) {
      this._instance = new OccupationsRepository();
    }
    return this._instance;
  }

  constructor() {
    // Create Logger
    this.logger = new Logger('OccupationsRepository');
  }

  // Get all occupations
  public async get(
    search: string,
    localize: boolean,
    userType: UserType
  ): Promise<Array<Occupation>> {
    // Get occupations
    const designationParam = search.trim().length > 0 ? `&designation=${search}` : '';
    const response: AxiosResponse<Array<Occupation>> = await BackendApiManager.instance.get<
      Array<Occupation>
    >(`/occupations?localize=${localize}${designationParam}&userType=${userType}`);

    return response.data;
  }

  // Get an occupation by id
  public async getById(id: string, localize: boolean): Promise<Array<Occupation>> {
    // Get occupation
    const response: AxiosResponse<Array<Occupation>> = await BackendApiManager.instance.get<
      Array<Occupation>
    >(`/occupations/${id}?localize=${localize}`);

    return response.data;
  }
}
